import React from "react";
import { injectIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import analiticaDerivacion from "../../assets/analitica-derivacion.png";
import historiaClinica from "../../assets/historia-clinica.png";
import logoMedical from "../../assets/logo-medical.png";
import martinaLupa from "../../assets/martina-lupa.png";
import { useGameTexts } from "../../hooks/useGameTexts";
import NextButton from "../../components/NextButton";
import { useLang } from "../../translations/i18n";
import { ROUTES } from "../../utils/constants";
import {
	modalAnaliticaDerivacion,
	modalHistoriaClinica,
} from "../../utils/logger";
import PatientAvatar from "../../components/PatientAvatar";

function Scenario1Intro({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const prevState = useLocation();

	const group = useSelector((state) => state.group, shallowEqual);
	const { texts, ready } = useGameTexts(group?.game);

	const title = texts["scenario1.intro.title"] ?? "";
	const question = texts["scenario1.intro.question"] ?? "";
	const description = texts["scenario1.intro.description"] ?? "";

	function getHistoriaClinicaData() {
		const prefix = "scenario1.intro.historiaClinica.";
		const data = {};
		Object.keys(texts).forEach((key) => {
			if (key.startsWith(prefix)) data[key.slice(prefix.length)] = texts[key];
		});
		if (texts["scenario1.intro.paciente"] != null) data.paciente = texts["scenario1.intro.paciente"];
		if (texts["scenario1.intro.edad"] != null) data.edad = texts["scenario1.intro.edad"];
		return Object.keys(data).length ? data : undefined;
	}

	function getAnaliticaDerivacionData() {
		const prefix = "scenario1.intro.analiticaDerivacion.";
		const data = {};
		Object.keys(texts).forEach((key) => {
			if (key.startsWith(prefix)) data[key.slice(prefix.length)] = texts[key];
		});
		if (texts["scenario1.intro.paciente"] != null) data.paciente = texts["scenario1.intro.paciente"];
		if (texts["scenario1.intro.edad"] != null) data.edad = texts["scenario1.intro.edad"];
		return Object.keys(data).length ? data : undefined;
	}

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas2">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div
					style={{ paddingLeft: "6vh", minHeight: "60vh" }}
					className="row d-flex justify-content-start align-items-start mt-5 pt-5"
				>
					{!ready ? (
						<div className="col-6 d-flex align-items-center">
							<div className="txtWhite">Cargando...</div>
						</div>
					) : (
					<>
					<div
						className="col-3 line-height-40"
						style={{ letterSpacing: 3 }}
					>
						<div className="txtWhite txt20">ESCENARIO 1</div>
						<div className="txtWhite txt30 bold">
							{title && title.indexOf("<") >= 0 ? (
								<span dangerouslySetInnerHTML={{ __html: title }} />
							) : (
								title
							)}
						</div>
					</div>
					<div className="col-3 d-flex justify-content-center mt-5">
						<PatientAvatar gameId={group?.game} defaultSrc={martinaLupa} width={300} />
					</div>
					<div className="col-6">
						<div className="d-flex flex-column align-items-center txtWhite text-center mt-5">
							<div className="txt20 bold">
								{question && question.indexOf("<") >= 0 ? (
									<span dangerouslySetInnerHTML={{ __html: question }} />
								) : (
									question
								)}
							</div>
							<div className="txt18 mt-3 w-75">
								{description && description.indexOf("<") >= 0 ? (
									<span dangerouslySetInnerHTML={{ __html: description }} />
								) : (
									description
								)}
							</div>
							<img
								className="mt-4 mb-3"
								width={194}
								src={historiaClinica}
								onClick={() => modalHistoriaClinica(getHistoriaClinicaData())}
							/>
							<img
								width={194}
								src={analiticaDerivacion}
								onClick={() => modalAnaliticaDerivacion(getAnaliticaDerivacionData())}
							/>
						</div>
					</div>
					</>
					)}
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton
						navigateTo={ROUTES.SCENARIO1_CONVERSATION_INTRO}
					/>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario1Intro);
